export default {"src":"/_next/static/media/EBAY.61648826.svg","height":18,"width":18};